export const PaymentMethodStatus = {
    /** 남은 금액 없음 */
    PAY_METHOD_NO_PAYMENT: 'PAY_METHOD_NO_PAYMENT',
    /** 선택된 카드 프로모션이 있음 */
    SELECTED_CARD_PROMOTION_EXIST: 'SELECTED_CARD_PROMOTION_EXIST',
    /** 선택된 프로모션과 다른 간편카드 추가됨 */
    DIFFERENT_ISSUER_BETWEEN_PROMOTION_AND_REGISTERED_CARD: 'DIFFERENT_ISSUER_BETWEEN_PROMOTION_AND_REGISTERED_CARD',
    NORMAL: 'NORMAL',
} as const

export type PaymentMethodStatusType = Constant<typeof PaymentMethodStatus>

export const RechargePaymentStatus = {
    /** 남은 금액 없음 */
    PAY_METHOD_NO_PAYMENT: 'PAY_METHOD_NO_PAYMENT',
    /** 후불결제 사용시 충전결제 불가 */
    RECHARGE_POINT_DISABLED_BY_PAY_LATER: 'RECHARGE_POINT_DISABLED_BY_PAY_LATER',
    /** 최소 충전 부족 */
    RECHARGE_POINT_LACK: 'RECHARGE_POINT_LACK',
    /** 월 충전 제한 */
    ONE_MONTH_RECHARGE_LIMITED: 'ONE_MONTH_RECHARGE_LIMITED',
    /** 월 충전 제한 AND 충전포인트 결제 가능 */
    ONE_MONTH_RECHARGE_LIMITED_AND_USE_COMPLEX: 'ONE_MONTH_RECHARGE_LIMITED_AND_USE_COMPLEX',
    /** 추가 결제수단 선택 필요 */
    SELECT_ADDITIONAL_PAY_METHOD: 'SELECT_ADDITIONAL_PAY_METHOD',
    /** 추가 결제수단 선택 됨 */
    ADDITIONAL_PAY_METHOD_SELECTED: 'ADDITIONAL_PAY_METHOD_SELECTED',
    /** 복합 결제 선택 */
    PAYMENT_USE_COMPLEX: 'PAYMENT_USE_COMPLEX',
    /** 충전포인트 (조회 실패 + 회원 조회 실패 + 충전 재시도 X) 불가 */
    CHARGE_POINT_FAIL: 'CHARGE_POINT_FAIL',
    /** 2.0, 4.1, 4.2 사용자 충전 불가 */
    NOT_RECHARGE_USER: 'NOT_RECHARGE_USER',
    /** 추가 결제수단 선택 필요하지만 선택 불가하여 결제 불가 */
    COMPLEX_PAYMENT_UNAVAILABLE: 'COMPLEX_PAYMENT_UNAVAILABLE',
    NORMAL: 'NORMAL',
} as const

export type RechargePaymentStatusType = Constant<typeof RechargePaymentStatus>

/** 선택 가능한 충전결제 status */
export const SelectableRechargePaymentStatus: RechargePaymentStatusType[] = [
    RechargePaymentStatus.CHARGE_POINT_FAIL,
    RechargePaymentStatus.NOT_RECHARGE_USER,
    RechargePaymentStatus.NORMAL,
]

export const NormalPaymentStatus = {
    /** 후불결제 선택시 무통장입금 불가 */
    PAY_LATER_IMPOSSIBLE_USE_VIRTUAL_ACCOUNT: 'PAY_LATER_IMPOSSIBLE_USE_VIRTUAL_ACCOUNT',
    NORMAL: 'NORMAL',
} as const

export const PointPaymentCase = {
    /** 네이버포인트 사용시 한도 초과 불가 */
    NAVER_POINT_OVER_USING_POINT: 'NAVER_POINT_OVER_USING_POINT',
    /** 포인트 머니 사용 순서 설정 불가 */
    NAVER_POINT_PREFERRED_EXHAUSTION_FAIL: 'NAVER_POINT_PREFERRED_EXHAUSTION_FAIL',
    /** 후불결제 사용시 한도 초과 불가 */
    PAY_LATER_OVER_USING_POINT: 'PAY_LATER_OVER_USING_POINT',
    /** 후불결제 사용시 포인트 전액 적용 필요 */
    PAY_LATER_EXHAUST_ALL_POINT_USE: 'PAY_LATER_EXHAUST_ALL_POINT_USE',
    /** 포인트 전액 사용불가시 후불결제 사용 불가 */
    PAY_LATER_NO_PAYMENT: 'PAY_LATER_NO_PAYMENT',
    /** 후불결제 가입대상자 조회 실패 */
    PAY_LATER_CANDIDATE_STATUS_FAIL: 'PAY_LATER_CANDIDATE_STATUS_FAIL',
    /** 포인트 상세설명 통합 모달 (25.04.16) */
    POINT_DESCRIPTION: 'POINT_DESCRIPTION',
    /** AML 결제한도 안내 */
    AML_LIMIT_DESCRIPTION: 'AML_LIMIT_DESCRIPTION',
} as const

export const DeliveryCase = {
    /** 안심번호 안내 */
    VIRTUAL_PHONE_NUMBER_SERVICE: 'VIRTUAL_PHONE_NUMBER_SERVICE',
    /** 배송지 목록 선택 */
    DELIVERY_ADDRESSES: 'DELIVERY_ADDRESSES',
    /** 개인통관고유부호 수집안내 */
    AGREED_WITH_COLLECTION_INFO: 'AGREED_WITH_COLLECTION_INFO',
    /** 개인통관고유부호 발급안내 */
    ISSUING_CLEARANCE_CODE_INFO: 'ISSUING_CLEARANCE_CODE_INFO',
    /** 우편번호 검색 */
    SEARCH_ADDRESS_BY_ZIPCODE: 'SEARCH_ADDRESS_BY_ZIPCODE',
    /** 배송지 목록/입력 스크린 */
    ADDRESS_BOOK: 'ADDRESS_BOOK',
    /** 수령위치/출입방법 입력 스크린 (C2) */
    DELIVERY_INSTRUCTION: 'DELIVERY_INSTRUCTION',
    /** 배송지 목록/입력 스크린 */
    DELIVERY_MANAGE: 'DELIVERY_MANAGE',
    /** 배송 메모 선택 */
    DELIVERY_MEMO_SELECT: 'DELIVERY_MEMO_SELECT',
    /** 배송 메모 수정 */
    DELIVERY_MEMO_CHANGE: 'DELIVERY_MEMO_CHANGE',
    /** 연락처 수정 */
    CONTACT_CHANGE: 'CONTACT_CHANGE',
}

export type DeliveryCaseType = Constant<typeof DeliveryCase>

export const CardPromotionCase = {
    /** 선택된 프로모션 카드사와 다른 간편 카드 추가시 프로모션 적용 불가 */
    ADD_INVALID_EASY_CARD_FOR_PROMOTION: 'ADD_INVALID_EASY_CARD_FOR_PROMOTION',
    /** 쿠폰 변경 시 프로모션 정보 초기화 */
    CHANGE_COUPON: 'CHANGE_COUPON',
    /** 간편결제 미연결 및 할인금액이 50만원 초과인 경우 간편계좌 연결 필요 */
    CONNECT_EASY_BANK: 'CONNECT_EASY_BANK',
    /** 프로모션 적용 후 상품금액이 0원 이하인 경우 프로모션 적용 불가 */
    INVALID_PRODUCT_AMOUNT: 'INVALID_PRODUCT_AMOUNT',
    /** 만 19세 미만인 경우 할인금액 45만원 초과 불가 */
    NO_ADULT_LIMIT_DISCOUNT_AMOUNT: 'NO_ADULT_LIMIT_DISCOUNT_AMOUNT',
    /** 유효성 검증 실패시 프로모션 적용 불가 */
    VALIDATION_FAIL: 'VALIDATION_FAIL',
    /** 프로모션 적용된 상태에서 간편 카드외 결제수단 사용 불가 */
    SELECT_NO_EASY_CARD_PAYMENT: 'SELECT_NO_EASY_CARD_PAYMENT',
    /** 프로모션을 적용하기 위한 최소 상품금액을 넘는 상품이 1개도 없을경우 */
    MINIMUM_PRODUCT_PRICE: 'MINIMUM_PRODUCT_PRICE',
    /** 적용가능한 프로모션 갯수가 너무 많아서, 계산이 기준시간 이상 걸릴떄 */
    TOO_MANY_PROMOTION: 'TOO_MANY_PROMOTION',
}

export const PaymentMethodEntry = {
    /** 초기화 */
    INITIALIZE: 'INITIALIZE',
    /** 현재 상태 유지 */
    STAY_CURRENT: 'STAY_CURRENT',
    /** 상태 변경 */
    CHANGE_ITEM: 'CHANGE_ITEM',
} as const

export type PaymentMethodEntryType = Constant<typeof PaymentMethodEntry>
